import { FaRegUser } from "react-icons/fa6";
import ReusableProfileCard from "../Profile/ReusableProfileCard";
import TextTranslate from "../../../utils/TextTranslate";

export default function GroupNameCard({
  value,
  onChange,
}: {
  value: string;
  onChange: (next: string) => void;
}) {
  return (
    <div className="overflow-hidden rounded-2xl bg-primary shadow-sm ring-1 ring-black/[0.04] dark:ring-white/[0.06]">
      <div className="px-4 pb-0 pt-3">
        <div className="text-[13px] font-medium uppercase tracking-wide text-lightText">
          <TextTranslate text="Group Name" />
        </div>
      </div>
      <ReusableProfileCard
        icon={<FaRegUser className="text-lg" />}
        value={value}
        onChange={onChange}
        hideRightArrow
        className="!pt-2"
      />
    </div>
  );
}
